module.exports = __webpack_public_path__ + "static/media/02.d0ddb7a8.jpg";